var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "card-item check-content",
      attrs: { id: "payment-summary-card" },
    },
    [
      _c("h3", { staticClass: "text-align-center" }, [
        _vm._v("Verifica tu transacción"),
      ]),
      _c("div", { staticClass: "check-content" }, [
        _c("div", { staticClass: "subtitle-content" }, [
          _c("div", { staticClass: "resume-item" }, [
            _c("span", { staticClass: "subtitle-resumen" }, [
              _vm._v("Resumen"),
            ]),
            _c(
              "div",
              { staticClass: "resume-text" },
              _vm._l(_vm.paymentsMap, function (operation, operationId, i) {
                return _c(
                  "p",
                  { key: `operation${i}` },
                  [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: operation.length,
                            expression: "operation.length",
                          },
                        ],
                        staticClass: "credit-info",
                      },
                      [_vm._v("Crédito hipotecario N°" + _vm._s(i + 1))]
                    ),
                    _vm._l(_vm.paymentsMap[operationId], function (payment, j) {
                      return _c(
                        "span",
                        { key: `payment${i}${j}`, staticClass: "fee-info" },
                        [
                          _vm._v(
                            " Cuota " +
                              _vm._s(
                                payment.paymentNumber +
                                  "/" +
                                  _vm.debt.filter(
                                    (operation) =>
                                      operation.operationId == operationId
                                  )[0].termAsMonths
                              ) +
                              ": "
                          ),
                          _c("strong", [
                            _vm._v(
                              "$ " +
                                _vm._s(
                                  new Intl.NumberFormat("de-DE").format(
                                    payment.secondaryCurrencyTotalMonthlyPayment
                                  )
                                )
                            ),
                          ]),
                        ]
                      )
                    }),
                  ],
                  2
                )
              }),
              0
            ),
          ]),
          _c("div", { staticClass: "details-item" }, [
            _c("span", { staticClass: "subtitle-resumen" }, [
              _vm._v("Detalle de la transacción"),
            ]),
            _c("div", { staticClass: "details-text" }, [
              _c(
                "table",
                { staticClass: "pay-resume" },
                _vm._l(_vm.transactionDataTitles, function (value, key, index) {
                  return _c(
                    "tr",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.transactionData[key],
                          expression: "transactionData[key]",
                        },
                      ],
                      key: `title-${index}`,
                    },
                    [
                      _c("td", { staticClass: "pay-info" }, [
                        _vm._v(_vm._s(value) + ":"),
                      ]),
                      _c("td"),
                      _c("td", { staticClass: "fee-info" }, [
                        _vm._v(_vm._s(_vm.transactionData[key])),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "amount-resume" }, [
          _c("span", { staticClass: "total" }, [_vm._v("Total pagado")]),
          _c("span", { staticClass: "amount-total" }, [
            _vm._v(_vm._s(_vm.transactionData.total)),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "download-end" },
          [
            _c(
              "router-link",
              {
                staticClass: "button is-button-primary transition-fast",
                attrs: { to: "/" },
              },
              [_vm._v("Finalizar")]
            ),
          ],
          1
        ),
        _vm._m(0),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stamp" }, [
      _c("img", { attrs: { src: require("@/ui/assets/img/stamp.svg") } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }